const allJs = require.context('../theme', true)